/*
 * cbf-adv2 — isolated behavior for the Alpine Footwear advertorial
 * "Why 255,000 People Replaced Their Sneakers With These Last Year".
 * Loaded only by layout/cbf-adv2.liquid.
 */

/*
 * Sticky announcement bar + close button.
 * Bar becomes bottom-pinned on mobile once the visitor scrolls past whichever
 * section carries data-cbf-adv2-sticky-trigger. Falls back to one viewport
 * height if that attribute isn't present yet (no sections built past section 1).
 * Close hides both the bar and the breadcrumb for the current page view only —
 * no sessionStorage, so both reappear on reload.
 */
(function () {
  'use strict';

  var bar = document.querySelector('[data-cbf-adv2-bar]');
  if (!bar) return;

  var closeBtn = bar.querySelector('[data-cbf-adv2-close]');
  var breadcrumb = document.querySelector('[data-cbf-adv2-breadcrumb]');
  var mobileQuery = window.matchMedia('(max-width: 767px)');
  var ticking = false;

  function getTriggerY() {
    var triggerSection = document.querySelector('[data-cbf-adv2-sticky-trigger]');
    if (triggerSection) {
      var rect = triggerSection.getBoundingClientRect();
      return rect.bottom + window.scrollY;
    }
    return window.innerHeight;
  }

  function updateSticky() {
    ticking = false;

    if (!mobileQuery.matches) {
      bar.classList.remove('is-sticky');
      return;
    }

    if (window.scrollY > getTriggerY()) {
      bar.classList.add('is-sticky');
    } else {
      bar.classList.remove('is-sticky');
    }
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(updateSticky);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', onScroll);
  } else if (mobileQuery.addListener) {
    mobileQuery.addListener(onScroll);
  }

  updateSticky();

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      bar.style.display = 'none';
      bar.classList.remove('is-sticky');
      if (breadcrumb) breadcrumb.style.display = 'none';
    });
  }
})();

/*
 * Smooth-scroll fallback for buttons with data-cbf-adv2-scroll.
 * Used when a button's URL is left blank in the customizer — scrolls to
 * the element matching the button's href anchor instead of jumping.
 */
(function () {
  'use strict';

  var scrollBtns = document.querySelectorAll('[data-cbf-adv2-scroll]');
  scrollBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var target = document.querySelector(btn.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });
})();
